import React, { useEffect, useState } from 'react';
import api from '../../utils/api';

function PaymentHistory() {
  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    api.get('/payments')
      .then(res => setPayments(res.data.payments || []))
      .catch(() => setError('Failed to load payment history'))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div>Loading payment history...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div className="container py-4">
      <h2>Payment History</h2>
      <table className="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Transaction ID</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p, i) => (
            <tr key={i}>
              <td>{p.payment_date}</td>
              <td>${p.amount}</td>
              <td>{p.payment_status}</td>
              <td>{p.transaction_id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default PaymentHistory;
